export const DefaultConfig: any = {
    responsive: true,
    displayModeBar: true,
    displaylogo: false,
    modeBarButtonsToRemove: [
        'pan2d', 'select2d', 'lasso2d', 'toImage', 'sendDataToCloud', 'hoverClosestCartesian',
        'hoverCompareCartesian', 'toggleHover', 'toggleSpikelines', 'zoom2d'
    ],
    scrollZoom: false,
};